import { StateStorage } from 'zustand/middleware';

const getSearchParams = () => new URLSearchParams(window.location.search);

const updateUrl = (params: URLSearchParams) => {
  const queryString = params.toString();
  const newUrl = `${window.location.pathname}${queryString ? `?${queryString}` : ''}${window.location.hash}`;
  window.history.replaceState(null, '', newUrl);
};

export const createQueryParamStorage = (storageKey: string): StateStorage => ({
  getItem: () => {
    const params = getSearchParams();

    return params.get(storageKey);
  },

  setItem: (_, newValue) => {
    const params = getSearchParams();
    params.set(storageKey, newValue);
    updateUrl(params);
  },

  removeItem: () => {
    const params = getSearchParams();
    params.delete(storageKey);
    updateUrl(params);
  },
});
